<template>
  <div class="boxtitle roundedblu">
    1.Self Registration
  </div>
  <div id="signup">
    <el-row class="left-align mt-4 mx-3"
      ><h2 style="font-family: NotesEsaRegular;">Sing Up</h2></el-row
    >

    <div class="mx-5 mt-2">
      <el-row class="f2">
        Self-registration can be performed by the user following few simple
        steps:
      </el-row>
      <el-row class="mx-3 mt-3 f2">
        1. Click on the 'User Profile Icon' in the Open Access Hub home page,
        then follow the 'Sign up' link.
      </el-row>
      <el-row class="mt-3 mx-5">
        <img src="../../assets/singup.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="mt-4 f2">
        2. Fill in the form in all its parts and click on 'Register'
      </el-row>
      <el-row class="mt-3 mx-5 mb-4">
        <img src="../../assets/singup2.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="f2 mb-3">
        When filling the registration form, please bear in mind that:
      </el-row>
      <ul class="left-align custom-list">
        <li>All the fields are mandatory</li>
        <li>
          The username cannot contain any of the following characters:
        </li>

        <li>
          + - &amp; | ! ( ) { } [ ] ^ " ~ * ? : \ $ % ' &lt;blank space&gt;
        </li>

        <li>
          passwords typed in the 'Password' and 'Confirm Password' fields must
          be identical;
        </li>
        <li>
          e-mail address typed in the 'E-mail' and 'Confirm E-mail' fields must
          be identical;
        </li>
        <li>
          the chosen username must not be already taken, otherwise the following
          error message is returned:
        </li>
      </ul>
      <el-row class="mt-3 mx-5 mb-4">
        <img src="../../assets/singup3.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="f2 mb-3">
        3. If everything goes well, a 'Registration Successful' message is
        displayed:
      </el-row>
      <el-row class="mt-3 mx-5 mb-4">
        <img src="../../assets/singup4.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="f2 mb-3 left-align"
        >4. At this stage, the Data Hub User Service will send an automatic
        notification to the provided e-mail address. Registration e-mails are
        usually received within few minutes from the registration procedure.
      </el-row>
      <el-row class="f2 mb-3 left-align"
        >5. Once the registration is confirmed, the new account will be
        automatically validated and enabled with the 'Search' and 'Download'
        rights.</el-row
      >
    </div>
  </div>

  <div id="login">
    <el-row class="left-align mt-4 mx-3"
      ><h2 style="font-family: NotesEsaRegular;">Login</h2></el-row
    >

    <div class="mx-5 mt-2">
      <el-row class="f2 left-align">
        Once registered, users can access the Open Access Hub home page by
        entering the username and password they have set up during the
        registration procedure.
      </el-row>
      <el-row class="left-align mt-2"
        >Click on the 'User Profile Icon' and insert the username and password
        in the relevant fields;
      </el-row>
      <el-row class="left-align mt-2"
        >Then click on the ‘Login’ button.
      </el-row>
      <el-row class="mt-3 mx-5 mb-4">
        <img src="../../assets/singup5.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="left-align mt-2"
        >If credentials are correctly inserted the following message will appear
        at the bottom right corner of the screen.
      </el-row>
      <el-row class="mt-3 mx-5 mb-4">
        <img src="../../assets/singup6.jpg" style="max-width: 90%;" />
      </el-row>
    </div>
  </div>

  <div id="passwdreset">
    <el-row class="left-align mt-4 mx-3"
      ><h2 style="font-family: NotesEsaRegular;">Password Reset</h2></el-row
    >
    <hr class="divider mx-3" />
    <div class="mx-5 mt-2">
      <el-row class="left-align mt-2 mx-3"
        >If credentials are not correctly inserted (i.e. wrong username or
        password) the following error message will appear.
      </el-row>
      <el-row class="mt-3 mx-5 mb-4">
        <img src="../../assets/singup7.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="left-align mt-2 mx-3"
        >Forgotten password can be retrieved by following these steps:
      </el-row>

      <ol class="numbered-text mt-3">
        <li>
          Click on the 'User Profile Icon' and follow the 'Forgot password?'
          active link.
        </li>
        <el-row class="mt-3 mx-4 mb-4">
          <img src="../../assets/singup8.jpg" style="max-width: 90%;" />
        </el-row>
        <li>
          Fill in the form in all its parts and click on 'Send. The system will
          send a web link to the user's email for resetting the password.
        </li>
        <el-row class="mt-3 mx-4 mb-4">
          <img src="../../assets/singup9.jpg" style="max-width: 90%;" />
        </el-row>
      </ol>
      <el-row class="left-align mt-2 mx-3"
        >If the password recovery procedure is correctly executed, the below
        confirmation message will appear:
      </el-row>
      <el-row class="mt-3 mx-4 mb-4">
        <img src="../../assets/singup10.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="left-align mt-2 mx-3">
        If the username and the email address entered are not the same ones used
        in the registration process the following error message will be
        displayed:
      </el-row>
      <el-row class="mt-3 mx-4 mb-4">
        <img src="../../assets/singup11.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="left-align mt-2 mx-3">
        An automatic e-mail containing the link to set up a new password will be
        sent. By clicking on the link you will be re-directed to a page to reset
        the password: type and confirm the new password. Click on 'Send' when
        done. The following successful message will confirm that the procedure
        is successfully completed:
      </el-row>
      <el-row class="mt-3 mx-4 mb-4">
        <img src="../../assets/singup12.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="left-align mt-2 mx-3"
        >You can now login to the Open Hub using the new password.
      </el-row>

      <el-row class="right-align mt-5 mb-3">
        <el-col :span="15" :offset="6">
          <!-- 使用 offset 来实现内容居中 -->
          <div class="right-align">back to top</div>
        </el-col>
        <el-col class="mx-1"  :span="1">
          <el-button @click="scrollToTop" class="custom-icon-button" size="mini" circle 
            ><el-icon :size="20"><ArrowUp></ArrowUp></el-icon
          ></el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { ArrowUp } from "@element-plus/icons";

export default {
  components: {
    ArrowUp,
  },
  setup() {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 使用平滑滚动效果
      });
    };
    return { ArrowUp,scrollToTop };
  },
};
</script>
<style scoped>
.custom-icon-button {
  background-color: #0073e6; /* 设置按钮背景颜色为蓝色 */
  color: #fff; /* 设置文本颜色为白色 */
  border-color: #0073e6; /* 设置边框颜色为蓝色 */
}
.boxtitle {
  margin: 5px !important;
  color: white !important;
  text-align: left;
}
.roundedblu {
  background: #1e364e;
  color: #fff;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  font-family: "NotesEsaRegular";
  font-size: 22px;
  padding: 15px;
  overflow: auto;
}
.f2 {
  font-size: 16px !important;
}

.left-align {
  text-align: left;
  font-family: "NotesEsaRegular" !important;
}
.right-align {
  text-align: right;
  font-family: "NotesEsaRegular" !important;
}

img {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5); /* 横向偏移，纵向偏移，模糊半径，颜色 */
}

.custom-list {
  list-style: none; /* 移除默认的列表标志 */
  padding: 0; /* 移除默认的内边距 */
}
.custom-list li {
  margin-bottom: 10px; /* 设置行间距，这里是10像素，根据需要调整 */
}

.custom-list li::before {
  content: "○"; /* Unicode字符编码或其他内容，可以替换为自定义标志 */
  margin-right: 5px; /* 可以增加标志和文本之间的间距 */
  color: #0073e6; /* 标志的颜色 */
}

.numbered-text {
  list-style: none; /* 移除默认的列表标志 */
  counter-reset: item-counter; /* 重置计数器 */
  padding-left: 20px; /* 设置左侧的内边距，以容纳编号 */
  text-align: left; /* 文本左对齐 */
}

.numbered-text li {
  position: relative;
  counter-increment: item-counter; /* 增加计数器的值 */
  margin-bottom: 10px; /* 设置行间距，根据需要调整 */
}

.numbered-text li::before {
  content: counter(item-counter) "."; /* 使用计数器的值作为编号 */
  position: absolute;
  left: -20px; /* 调整编号的位置 */
  font-weight: bold; /* 可选，设置编号的样式 */
  color: #0073e6; /* 可选，设置编号的颜色 */
}
</style>
